import { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { AppContext } from 'commons-ui';
import useService from '../../utils/useService';
import { getFormDefaults } from '../../utils/formConfig';
import { dehydrateFormData } from '../../utils/formDataParser';
import { ISegmentOffer, ITDSAbsorptionOfferRawData } from '../../utils/type';
import { ICustomResponse } from '../../../tdsConfigs/utils/type';

const useCreate = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { app, showAlert } = useContext(AppContext);
	const history: any = useHistory();
	const { requestCreateOffer } = useService();

	const createOffer = (tdsAbsorptionOffer: ISegmentOffer) => {
		setShowLoader(true);
		requestCreateOffer(app.appName, { ...tdsAbsorptionOffer }).then(
			(res: ICustomResponse) => {
				if (res?.status !== 200 || !res?.data?.success) {
					showAlert(res?.data?.error || 'Error occured while creating the TDS Offer', { type: 'error' });
					setShowLoader(false);
				} else {
					showAlert('Offer Created');
					history.goBack();
				}
			},
			(err: any) => {
				showAlert(`Error: ${err?.response?.data?.error}`, { type: 'error' });
				setShowLoader(false);
			}
		);
		return {};
	};

	const handleFormSubmit = (submittedData: ITDSAbsorptionOfferRawData) => {
		createOffer(dehydrateFormData(submittedData));
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	const segmentList: { id: string; label: string[] } = history?.location?.state?.segmentList;
	return { data: getFormDefaults(segmentList), showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};

export default useCreate;
